import { select, putResolve } from "redux-saga/effects";
import { MyTripsFilter } from "redmond";

import { IStoreState } from "../../../reducers/types";
import {
  getExistingStateVariables,
  parseQueryString,
} from "./populateTripQueryParamsSaga";
import { actions } from "../actions";

export interface ITripsParsedQuery {
  tripsFilter: string;
  tripId: string;
  isTravelApp: string | string[] | null;
}

const getFormattedMyTripsFilter = (queryParamsTripFilter?: string) => {
  const lowerCaseQueryParamsTripFilter = queryParamsTripFilter?.toLowerCase();
  return [
    MyTripsFilter.PAST_TRIPS,
    MyTripsFilter.UPCOMING_TRIPS,
    MyTripsFilter.CANCELED_TRIPS,
    MyTripsFilter.TRAVEL_CREDITS,
    MyTripsFilter.WATCHED_TRIPS,
    MyTripsFilter.TRIPS_WITH_OFFERS,
  ].find((filter) => filter.toLowerCase() === lowerCaseQueryParamsTripFilter);
};

export function* setUpMyTripsParams(
  action:
    | actions.IFetchHotels
    | actions.IFetchFlights
    | actions.IFetchCars
    | actions.IFetchHomes
    | actions.IFetchExperiences
    | actions.IFetchPackages,
) {
  const state: IStoreState = yield select();
  const { history } = action;

  const { tripsFilter, tripId } = getExistingStateVariables(state);

  const {
    tripId: queryParamsTripId,
    tripsFilter: queryParamsTripFilter,
    isTravelApp,
  }: ITripsParsedQuery = parseQueryString(history);

  const formattedQueryParamsTripFilter = getFormattedMyTripsFilter(
    queryParamsTripFilter,
  );

  if (formattedQueryParamsTripFilter !== tripsFilter) {
    if (formattedQueryParamsTripFilter) {
      yield putResolve(actions.setTripsFilter(formattedQueryParamsTripFilter));
    } else {
      yield putResolve(
        actions.populateTripQueryParams(
          history,
          queryParamsTripId ? { tripId: queryParamsTripId } : undefined,
        ),
      );
    }
  }

  return {
    tripsFilter: queryParamsTripFilter || tripsFilter,
    tripId: queryParamsTripId || tripId,
    isTravelApp,
  };
}
